// Load gtag script
export const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

// Add environment check
const isDevelopment = import.meta.env.DEV;

export const pageview = (url) => {
  if (!isDevelopment && typeof window.gtag !== "undefined") {
    window.gtag("config", GA_MEASUREMENT_ID, {
      page_path: url,
    });
  }
};

// Initialize gtag if not already loaded
export const initGA = () => {
  // Add gtag script to head if not present
  if (!window.gtag) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: false, // We'll handle page views manually for SPA
    });
  }
};

// Track custom events
export const event = ({ action, category, label, value }) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Helper for common events
export const trackButtonClick = (buttonName) => {
  event({
    action: "click",
    category: "Button",
    label: buttonName,
  });
};

export const trackFormSubmit = (formName) => {
  event({
    action: "submit",
    category: "Form",
    label: formName,
  });
};
